"use client";

import useAppMessage from "@lib/user/useAppMessage";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Link, styled } from "@mui/material";

const Banner = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "var(--signal-success-bg)",
  color: "var(--signal-success-text)",
  padding: "var(--space-3) var(--space-4)",
  borderRadius: "var(--radius-md)",
  border: "1px solid var(--signal-success-border)",
  margin: "40px 46px 0",
}));

const Emoji = styled("span")({
  fontSize: "1.5rem",
  marginRight: "10px",
});

const Message = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "var(--space-3)",
  fontSize: "14px",
});

const DismissButton = styled(Link)(() => ({
  color: "inherit",
  lineHeight: "1rem",
}));

export default function AppMessageBanner() {
  const { message, dismissMessage } = useAppMessage();

  if (!message) {
    return null;
  }

  return (
    <Banner>
      <Emoji>🎉</Emoji>
      <Message>
        <strong>{message.primary}</strong>
        {message.secondary}
      </Message>
      <DismissButton href="#" onClick={dismissMessage}>
        <CloseIcon />
      </DismissButton>
    </Banner>
  );
}
